import "./src/styles/global.css"
import "./src/styles/colors.css"
import "./src/styles/contact.css"